document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".media-with-text__button"); 
  const mediaWithTextItems = document.querySelectorAll(".media-with-text__content li");

  if (buttons.length) {
      buttons.forEach(button => {

          button.addEventListener("click", function () {
              mediaWithTextItems.forEach(li => {
                  li.classList.add("media-with-text__li-show"); 
              });

              button.classList.add("media-with-text__button-hide"); 
          });
      });
  }
});